import axios from 'axios'
import HipsSearchMenu from '../HipsSearchMenu/index.vue';
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { HipsModule } from "@/modules/HipsModule";
import { FrameStore } from "@/modules/base";

@Component({
  components: { HipsSearchMenu },
})
export default class extends Vue {
  @Prop({ required: true })
  frameStore!: FrameStore<typeof HipsModule>

  @Prop({ required: true })
  module!: HipsModule

  get baseUrl() {
    const h = this.frameStore.baseUrl
    if (h === undefined) {
      return ''
    } else {
      return h
    }
  }

  set baseUrl(v: string) {
    v = v.trim()
    if (v === '') {
      this.frameStore.baseUrl = undefined
    } else {
      this.frameStore.baseUrl = v
    }
  }

  properties: KV[] = []

  @Watch('baseUrl')
  async onBaseUrlChagne() {
    this.properties = []
    if (this.baseUrl !== '') {
      const { data: rawProperties } = await axios.get<string>(`${this.baseUrl}/properties`, { responseType: 'text' })
      this.properties = parseRawProperties(rawProperties)
    }
  }

  isLink(s: string) {
    return s !== undefined && !!s.match(/^https?:\/\//)
  }
}

function parseRawProperties(rp: string) {
  const properties: KV[] = []
  for (const line of rp.split('\n')) {
    if (line.match(/^\s*#/)) { // comment
      properties.push({ commnet: line })
    } else {
      const [key, value] = line.split('=')
      if (value !== undefined) {
        properties.push({ key: key.trim(), value: value.trim() })
      }
    }
  }
  return properties
}

type KV = { key: string, value: string } | { commnet?: string }
